<template>
    <div class="tep-opu-si-view">
        <ai-grid-edit
            ref='gridRef'
            :meta='gridMeta'
            :args="gridArgs"
            :to-remove-toolbar-items-names='removeGridToolbarBtns'
            :showFooter="false"
            @onAddClickEvent="onAddClickEvent"
            :addCustomClick="addCustomClick"
            @user-data-changed='onUserDataChanged'
            @toolbar-button-click="onToolbarClickGrid"
            @changesSavedSuccessfully="onChangesSavedSuccessfully"
            class="tep-opu-si-grid"
        ></ai-grid-edit>
        <dx-popup
            ref="popupRef"
            height="95%"
            title="Типы приборов измерения"
            :drag-enabled="true"
            :hide-on-outside-click="false"
            :show-close-button="true"
            :show-title="true"
            :visible="popupVisible"
            @hiding='onClosePopup'
        >
            <qs-tip-pruu-view
                ref='nsiRef'
                :fromCard="true"
                @choose-nsi="onChooseNsi"
                class="qs-tip-pruu-view"
            />
        </dx-popup>
    </div>
</template>
<script>
export default {
    name: 'tep-opu-si-grid',
};
</script>
<script setup>

import { computed, inject, onMounted, ref, watch } from 'vue';
import { DxPopup } from 'devextreme-vue';
import { getCookie } from '@/utils/cookies';
import QsTipPruuView from '@/views/tep/tep-nsi/qs-tip-pruu-view.vue';
import tepCardsStore from '@/views/tep/tep-grid/store/tep-cards-store';
import AiGridEdit from '@/components/ai-grid-edit/ai-grid-edit.vue';

const userData = inject('userData');

const gridRef = ref(null);
const popupVisible = ref(false);
const gridArgs = ref(null);
const popupRef = ref(null);
const nsiRef = ref(null);
const defaultSaveArgs = ref({kod_sx: -1, dep: +getCookie('dep')});
const addCustomClick = ref(true);
const nsiChoiceData = ref({});
const statusSaveButtons = ref(null);

const props = defineProps({
    serverData: {
        type: Object,
        default: () => {}
    },
    callbacks: {
        type: Object,
        default: () => ({ userDataChanged: null }),
    },
});

onMounted  (async () => {
    defaultSaveArgs.value.kod_sx = props?.serverData?.kod;
    const defaultGridArgs = {
        select: {
            select_args: { ...defaultSaveArgs.value },
        },
        save: {
            update_args: { ...defaultSaveArgs.value },
            insert_args: { ...defaultSaveArgs.value },
            delete_args: { ...defaultSaveArgs.value },
        },
    };
    gridArgs.value = { ...defaultGridArgs };
    if(props?.serverData?.kod) {
        await gridRef.value?.setDataSource(null, gridArgs.value.select);
        if(radioPribFlag.value  === 'active_prib') {
            await  filterDataPrib();
        }
    }
    statusSaveButtons.value = await gridRef.value?.getButtonsRefs();
});

const radioPribFlag = computed(() => {
    return tepCardsStore.state.radioPribFlag;
});

const statusSaveButton = computed( () => {
    const buttonsRefs = statusSaveButtons?.value;
    tepCardsStore.changeStatusSaveButton(buttonsRefs?.value?.isSaveButtonDisabled);
    return buttonsRefs?.value?.isSaveButtonDisabled;
})

const isSaveGrid = computed(() => {
    return tepCardsStore.state.isSaveGrid
})


watch(radioPribFlag, async (newValue) => {
    if (newValue === 'all_prib') await gridRef.value?.gridInstance.clearFilter();
    else if(newValue === 'active_prib') {
        await filterDataPrib();
    }
});

watch(statusSaveButton, async (newValue) => {
    if(!newValue) {
        userData.value['is_grid_changed'] = Number(!userData.value['is_grid_changed']);
    } else if(newValue) {
        userData.value['is_grid_changed'] = props.serverData['is_grid_changed'];
    }
    if (props.callbacks.userDataChanged) props.callbacks.userDataChanged();
});

watch(isSaveGrid, async (newValue) => {
    if(newValue) {
        await saveGrid();
    }
});

const saveGrid = (async () => {
    const processedData = await gridRef.value?.prepareChangesForSavingFunc();
    const savePromise = await gridRef.value?.save(processedData);
    await tepCardsStore.setSaveGridPromise(savePromise);
    await savePromise;
    await tepCardsStore.changeSavegrid(false);
})

const filterDataPrib = (async() => {
    const today =  new Date().toISOString().split('T')[0];
    await gridRef.value?.gridInstance.filter(
        ['data_out', '>', today],
        'or',
        ['data_out', '=', null],
    );
})

const onToolbarClickGrid = (async () => {
   await filterDataPrib();
});

const onAddClickEvent = (async () => {
    popupVisible.value = true;
});

const onClosePopup = ((e) => {
    if (popupVisible.value) {
        e.cancel = true;
        nsiRef.value?.beforeNsiClose();
    }
});

const onChooseNsi = (async (nsiChoiceItem, isNsiChoice) => {
    if (!isNsiChoice) {
        popupVisible.value = false;
        popupRef.value?.instance.hide();
        await nsiRef.value.clearData();
        return;
    }
    if(nsiChoiceItem) addCustomClick.value = false;
    nsiChoiceData.value = {...nsiChoiceItem };
    await setTimeout(async() => {
        await gridRef.value.addClick();
        popupVisible.value = false;
        await popupRef.value?.instance.hide();
        await nsiRef.value?.clearData();
    },0)
});

const onUserDataChanged = async (userData) => {
    const dataPovArr = userData.changes?.gridChanges?.filter(item => item.data.data_pov);
    if(dataPovArr.length > 0) {
        const dataGrid = await gridRef.value?.getGridDataSource() ?? [];
        dataPovArr.map( item => {
            const int = item?.data?.int ? item?.data?.int :  dataGrid.find(i => i.kod === item.key)?.int
            const dateStr =item.data.data_pov;
            const dateObj = new Date(dateStr);
            dateObj.setFullYear(dateObj.getFullYear() + int)
            item.data.data_pov_end = dateObj;
        })
    }
    let insertEventData = userData.changes?.gridChanges?.filter(el => el.type === 'insert') ?? [];
    insertEventData = insertEventData.filter(el => el.data.name_uu === null);
    for (const insertEvent of insertEventData) {
        await beforeInsertRow(insertEvent);
    }
};

const beforeInsertRow = async (insertEvent) => {
   if(insertEvent.data.name_uu !== null) return;
   if(nsiChoiceData.value.length !== 0) {
        for (let key in insertEvent.data) {
            if(Object.prototype.hasOwnProperty.call(nsiChoiceData.value, key)) {
                if(key === 'greyEminence') continue;
                insertEvent.data[key] = nsiChoiceData.value[key];
                insertEvent.data['tip_pr'] = nsiChoiceData.value['kod_tip_pruu'];
                insertEvent.data['name_uu'] = nsiChoiceData.value['name_vid'];
                insertEvent.data['tip_pr_r'] = nsiChoiceData.value['kod_r'];
                insertEvent.data['name_tip'] = nsiChoiceData.value['name_uu'];
                insertEvent.data['izm'] = nsiChoiceData.value['izm'];
                insertEvent.data['name_izm'] = nsiChoiceData.value['name_izm'];
                insertEvent.data['int'] = nsiChoiceData.value['mpi'];
                insertEvent.data['name_int'] = nsiChoiceData.value['name_mpi'];
                insertEvent.data['n_greest'] = nsiChoiceData.value['n_greest'];
                insertEvent.data['obozn_t'] = nsiChoiceData.value['obozn_t'];
                insertEvent.data['per_chas_arx'] = nsiChoiceData.value['per_chas_arx'];
                insertEvent.data['per_sut_arx'] = nsiChoiceData.value['per_sut_arx'];
                insertEvent.data['work'] = nsiChoiceData.value['work'];
                insertEvent.data['data_pov'] = new Date();
                const date = new Date();
                date.setFullYear(date.getFullYear() + nsiChoiceData.value['mpi']);
                insertEvent.data['data_pov_end'] = date;
             }
        }
        nsiChoiceData.value = {};
    }
    addCustomClick.value = true;
};

const removeGridToolbarBtns = [ 'edit', 'choice', 'show-column-chooser', 'searchPanel', 'copy', 'export'];

const gridMeta =  {
    'keyExpr': 'kod',
    'isFilterPanelVisible': false,
    'columns': [
        {
            'name': 'kod',
            'caption': 'kod',
            'dataField': 'kod',
            'allowEditing': false,
            'width': 250,
            'index': 1,
            'visible': false,
        },
        {
            'name': 'npp',
            'caption': '№ п/п',
            'dataField': 'npp',
            'allowEditing': false,
            'width': 70,
            'index': 4,
            'visible': true,
            'fixed': true,
            'dataType': 'number'
        },
        {
            'name': 'name_uu',
            'caption': 'Вид СИ',
            'dataField': 'name_uu',
            'allowEditing': false,
            'width': 200,
            'index': 5,
            'visible': true,
        },
        {
            'name': 'mesto',
            'caption': 'Место фикс.',
            'dataField': 'mesto',
            'allowEditing': true,
            'width': 130,
            'index': 6,
            'visible': true,
            "editor": {
                "type": "ai-drop-down",
                "text": "name_mesto"
            },
            "component": {
                "name": "lookup_uu_mesto",
                "id": "kod",
                "text": "name",
                'minHeight': '200px'
            }
        },
        {
            'name': 'obozn_t',
            'caption': 'Обозначение СИ',
            'dataField': 'obozn_t',
            'allowEditing': false,
            'width': 130,
            'index': 7,
            'visible': true,
        },
        {
            'name': 'name_tip',
            'caption': 'Тип. марка',
            'dataField': 'name_tip',
            'allowEditing': false,
            'width': 130,
            'index': 8,
            'visible': true,
        },
        {
            'name': 'nomer',
            'caption': 'Заводской номер',
            'dataField': 'nomer',
            'allowEditing': true,
            'width': 130,
            'index': 9,
            'visible': true,
        },
        {
            'name': 'dim',
            'caption': 'Диаметр (мм)',
            'dataField': 'dim',
            'allowEditing': true,
            'width': 130,
            'index': 10,
            'visible': true,
            "editor": {
                "type": "ai-drop-down",
                "text": "dim"
            },
            "component": {
                "name": "lookup_uu_diam",
                "id": "kod",
                "text": "kod",
                'minHeight': '200px'
            }
        },
        {
            'name': 'izm',
            'caption': 'Принцип измерения',
            'dataField': 'izm',
            'allowEditing': false,
            'width': 250,
            'index': 11,
            'visible': false,
        },
        {
            'name': 'name_izm',
            'caption': 'Принцип измерения',
            'dataField': 'name_izm',
            'allowEditing': false,
            'width': 130,
            'index': 12,
            'visible': true,
        },
        {
            'name': 'data_pov',
            'caption': 'Дата поверки',
            'dataField': 'data_pov',
            'allowEditing': true,
            'width': 130,
            'index': 13,
            'visible': true,
            'dataType': 'date',
            'format': 'yyyy-MM-dd',
        },
        {
            'name': 'int',
            'caption': 'int',
            'dataField': 'int',
            'allowEditing': false,
            'width': 250,
            'index': 15,
            'visible': false,
        },
        {
            'name': 'name_int',
            'caption': 'Межпов. интер.',
            'dataField': 'name_int',
            'allowEditing': false,
            'width': 130,
            'index': 16,
            'visible': true,
        },
        {
            'name': 'data_pov_end',
            'caption': 'Дата окончания поверки',
            'dataField': 'data_pov_end',
            'allowEditing': true,
            'width': 130,
            'index': 17,
            'visible': true,
            'dataType': 'date',
            'format': 'yyyy-MM-dd',
        },
        {
            'name': 'per_chas_arx',
            'caption': 'Период час.архив. (сут.)',
            'dataField': 'per_chas_arx',
            'allowEditing': false,
            'width': 130,
            'index': 18,
            'visible': true,
            'dataType': 'number'
        },
        {
            'name': 'per_sut_arx',
            'caption': 'Период сут.архив. (сут.)',
            'dataField': 'per_sut_arx',
            'allowEditing': false,
            'width': 130,
            'index': 19,
            'visible': true,
            'dataType': 'number'
        },
        {
            'name': 'n_greest',
            'caption': '№ в Гос. реестре',
            'dataField': 'n_greest',
            'allowEditing': true,
            'width': 130,
            'index': 20,
            'visible': true,
        },
        {
            'name': 'work',
            'caption': 'Завод изготовитель',
            'dataField': 'work',
            'allowEditing': false,
            'width': 130,
            'index': 21,
            'visible': true,
        },
        {
            'name': 'loss_press',
            'caption': 'Гидравл. под давл. (м в ст)',
            'dataField': 'loss_press',
            'allowEditing': true,
            'width': 130,
            'index': 22,
            'visible': true,
            'dataType': 'number'
        },
        {
            'name': 'data_out',
            'caption': 'Дата прек. действ. приб.',
            'dataField': 'data_out',
            'allowEditing': true,
            'width': 130,
            'index': 23,
            'visible': true,
            'dataType': 'date',
            'format': 'yyyy-MM-dd',
        },
        {
            'name': 'prim',
            'caption': 'Примечание',
            'dataField': 'prim',
            'allowEditing': true,
            'width': 130,
            'index': 24,
            'visible': true,
        },
    ],
    'api': {
        'select': 'tep-grid./tep/qr-uu-si-grid/select/get',
        'save': 'tep-grid./tep/qr-uu-si-grid/save/set',
    },
    'viewId': 'view-qr-uu-si-grid',
};
</script>
<style scoped>
.tep-opu-si-view :deep(.dx-toolbar-item-content .dx-button) {
    background-color: transparent;
}

.tep-opu-si-view :deep(.dx-texteditor.dx-editor-filled) {
    border-radius: 5px;
    min-height: 26px;
}
.tep-opu-si-view :deep(.dx-texteditor-container) {
    border-radius: 5px;
    min-height: 26px;
}
:root .tep-opu-si-grid :deep(table td .overflow-hidden) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>

